<template>
  <span class="thumbtack-rating">
    <i class="icon-star" v-for="index in Math.floor(parseFloat(rating))" :key="index"></i>
    <i class="icon-star-half" v-if="rating > Math.floor(parseFloat(rating))"></i>
    <i class="icon-star-o" v-for="index in (5 - Math.ceil(rating))" :key="index"></i>
  </span>
</template>

<script src="./thumbtackrating.js"></script>

<style lang="scss">
@use './thumbtackrating.scss' as *;
</style>